import { render, staticRenderFns } from "./ParticlesGenerator.vue?vue&type=template&id=918d15fe&scoped=true"
import script from "./ParticlesGenerator.vue?vue&type=script&lang=js"
export * from "./ParticlesGenerator.vue?vue&type=script&lang=js"
import style0 from "./ParticlesGenerator.vue?vue&type=style&index=0&id=918d15fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918d15fe",
  null
  
)

export default component.exports